'use client';

import { useEffect, useRef, useState } from 'react';
import { type NodeProps } from '@xyflow/react';
import { NodeShell } from '../BaseNode';
import { usePipelineStore } from '@/lib/pipeline/store';
import { ParamNameField } from '../ParamNameField';

export default function TextInputNode({ id, data }: NodeProps) {
  const update = usePipelineStore((s) => s.updateNodeData);
  const d = data as { text?: string; param?: string | null };

  // Local mirror so typing never round-trips through the store (no caret jump).
  const taRef = useRef<HTMLTextAreaElement>(null);
  const [text, setText] = useState(d.text ?? '');
  useEffect(() => {
    if (document.activeElement !== taRef.current) setText(d.text ?? '');
  }, [d.text]);

  return (
    <NodeShell id={id} type="textInput">
      <textarea
        ref={taRef}
        className="input nodrag nowheel w-full text-sm min-h-[70px] resize-none"
        placeholder="Plain text…"
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          update(id, { text: e.target.value });
        }}
      />
      <ParamNameField id={id} value={d.param} />
    </NodeShell>
  );
}
